import { render, staticRenderFns } from "./supplementary.vue?vue&type=template&id=877de96e&scoped=true"
import script from "./supplementary.vue?vue&type=script&lang=js"
export * from "./supplementary.vue?vue&type=script&lang=js"
import style0 from "./supplementary.vue?vue&type=style&index=0&id=877de96e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "877de96e",
  null
  
)

export default component.exports